import debounce from 'lodash';
import bpConfig from 'Config/breakpoints.json';
import objectMap from '../utils/objectMap';

const breakpoints = objectMap( bpConfig.breakpoints, val => parseInt(val,10) );

export default {

  getBreakpoint(key) {
    return breakpoints[key];
  },

  debounced(fn) {
    return _.debounce( () => fn(), 200);
  },

  maxWidth(key, callback) {
    let debounced = this.debounced( () => {
      if ( window.innerWidth < breakpoints[key] ) callback();
    });
    window.addEventListener('resize', debounced);
    window.addEventListener('popstate', debounced.cancel);
  },

  minWidth(key, callback) {
    let debounced = this.debounced( () => {
      if ( window.innerWidth >= breakpoints[key] ) callback();
    });
    window.addEventListener('resize', debounced);
    window.addEventListener('popstate', debounced.cancel);
  },

}
